/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 11:08:53                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-27 10:16:57                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
    * Components
  * WorkorderSection: dashboard workorders cards 
*/

/* Imports */
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
/***/

/* Services */
import { createDateRangeQuery, searchWithFilters } from "../../../../../services/api/search";
/***/

/* Components */
import DashboardCardLayout from "../DashboardCardLayout";
import WorkorderDashCard from "../../../../../components/data/workorder/WorkorderDashCard";
import Loading from "../../../../../components/loading/Loading";
/***/

/**
* WorkorderSection: dashboard workorders cards 
* display workorders summarized informations
*/
export default function WorkorderSection({ from, to }: { from: Date; to: Date }) {
  const navigate = useNavigate();
  const [workorders, setWorkorders] = useState<EasyTech.Workorder[]>();
  const MAX_LENGTH = 3;

  useEffect(() => {
    setWorkorders(undefined);
    searchWithFilters<EasyTech.Workorder>("workorders", {
      paginate: { pageSize: MAX_LENGTH, pageNumber: 0 },
      order: { by: "created", direction: "DESC" },
      queries: [createDateRangeQuery("created", from, to)]
    })
      .then((ret) => setWorkorders(ret.data))
      .catch((err) => {
        console.error(err);
        setWorkorders([]);
      });
  }, [from, to]);

  return(
    <div>
      
      <DashboardCardLayout  title={t("workorder:title")}
                            path="/workorders">
        {workorders ?
          workorders.length > 0 ?
            <>
              {workorders.slice(0, MAX_LENGTH).map((el) => (
                <WorkorderDashCard key={el.ref} onClick={() => navigate(`/workorders/${el.id}`)} workorder={el}/>
              ))}
            </>
          : <span className="no-item">{t("common:noWorkorders")}</span>
        : <Loading/>}
      </DashboardCardLayout>
    </div>
  );  
}
/***/
